<template>
    <div class="upload-logo__cover">
        <div class="logo mb-10">
            <img src="@/assets/logo.svg" alt="">
        </div>

        <div class="upload" 
             @dragenter.prevent="dragEnter"
             @dragleave.prevent="dragLeave"  
             @dragover.prevent
             @drop.prevent>
            <label class="--font">Upload company {{ heading }} </label>
            <input 
                type="file" 
                id="upload-logo__cover" 
                style="display : none;"
                accept="image/*" 
                @change="setFileVariable">
            <label for="upload-logo__cover" class="upload-button flex pointer --green">Upload {{ heading }} from your computer</label>

            <div class="drag-drop secondary-font flex" @drop.prevent="dropImages">
                <p>Or drag and drop your logo here</p>
                <p>.jpeg and .png files supported</p>

                <div v-if="logo && $route.name === 'setupProfileLogo'">   
                    <img :src="logoURL" alt="">
                    <v-icon color="white" class="remove-image pointer" size="17" @click.native="removeSelectedImage('logo')">
                        mdi-close
                    </v-icon>
                </div>

                <div v-if="cover && $route.name === 'setupProfileTimeline'">
                    <img :src="coverURL" alt="">
                    <v-icon color="white" class="remove-image pointer" size="17" @click.native="removeSelectedImage('cover')">
                        mdi-close
                    </v-icon>
                </div>
            </div>
        </div>

        <div class="buttons-section flex">
            <button class="previous --green" @click="checkRouteAndRedirect">Previous</button>
            <button 
                class="next green-background white--text" 
                @click="uploadLogoOrTimelinePhoto"
                :disabled="nextButtonDisableState">
                Next
                <v-progress-circular indeterminate size="13" class="mb-1 mx-2" width="2" v-if="loader"/>
            </button>
        </div>
    </div>
</template>

<script>
import accessToken from '../../../helpers/accessToken';
import API_URL from '../../../helpers/apiUrls'
export default {
    name : 'uploadLogoOrCover',

    data() {
        return {
            heading : '',
            logo : null,
            cover : null,
            logoURL : null,
            coverURL : null,
            loader : false,
            isDragged : false,
            Preview : null
        }
    },

    computed : {
        user() {
            return this.$store.getters['mainStore/GET_USER_DETAILS'];
        },

        nextButtonDisableState() {
            if(this.$route.name === 'setupProfileLogo') {
                if(this.logo) {
                    return false;
                }
                return true;
            }
            else {
                if(this.cover)
                    return false;
                return true;
            }
        },
    },

    watch : {
        logo : function(value) {
            if(!value)
                this.$emit('removeLogo');
        },

        cover : function(value) {
            if(!value)
                this.$emit('removeCover')
        }
    },

    created() {
        if(this.$route.name === 'setupProfileLogo')
            this.heading = 'Logo'
        else
            this.heading = 'Cover Image'
        
        this.$emit('setLogoAndCoverLayout');
    },

    methods : {
        dragEnter() {
            this.isDragged = true;
        },
        dragLeave() {
            this.isDragged = false;
        },
        dropImages(event) {
            this.isDragged = false;
            if(event.dataTransfer.files.length > 1) {
                this.showToast('You can only select 1 image here!', 'error', 100000);
                return;
            }
            if(this.$route.name === 'setupProfileLogo') {
                this.logo = event.dataTransfer.files[0];
                this.logoURL = URL.createObjectURL(event.dataTransfer.files[0])
                this.$emit('logoURL', this.logoURL);

            }
            else {
                this.cover = event.dataTransfer.files[0];
                this.coverURL = URL.createObjectURL(event.dataTransfer.files[0])
                this.$emit('coverURL', this.coverURL)
            }
        },

        removeSelectedImage(ImageType) {
            if(ImageType === 'logo') {
                this.logo = null;
                this.logoURL = null;
            }
            else if(ImageType === 'cover') {
                this.cover = null;
                this.coverURL = null;
            }
        },

        setFileVariable(event) {
            if(this.$route.name === 'setupProfileLogo') {
                this.logo = event.target.files[0];
                this.logoURL = URL.createObjectURL(event.target.files[0])
                this.$emit('logoURL', this.logoURL)
            }
            else {
                this.cover = event.target.files[0];
                this.coverURL = URL.createObjectURL(event.target.files[0])
                this.$emit('coverURL', this.coverURL)
            }
        },

        uploadLogoOrTimelinePhoto() {
            this.loader = true;
            const successHandler = response => {
                if(response.status === 200) {
                    if(this.$route.name === 'setupProfileLogo') {
                        this.$router.push({ name : 'setupProfileTimeline' });
                        this.heading = 'Cover Image';
                    }
                    else {
                        // SET ACCESS TOKEN HERE
                        accessToken.setCredentials(
                            this.$store.state.mainStore.temporaryAccessToken,
                            this.$store.state.mainStore.temporaryRefreshToken,
                            this.user.brand.brandID,
                            this.user.name,
                            this.user.avatar
                        )
                        this.$router.replace({ name : 'MainDashboard' });
                        this.showToast('You have successfully logged in!')
                    }
                    this.loader = false;
                }
            }

            const errorHandler = error => {
                this.showToast('Something went wrong internally!', 'error', 10000);
                this.loader = false;
            }
            
            const formData = new FormData();

            if(this.$route.name === 'setupProfileLogo')
                formData.append('logo_image', this.logo);
            else
                formData.append('time_line_image', this.cover);

            const headers = {
                'Authorization' : `Bearer ${this.$store.state.mainStore.temporaryAccessToken}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID')  
            }

            this.requestPATCH(
                `${API_URL.brand}/${this.user.brand.brandID}/_partial_update`, 
                formData,
                headers,
                successHandler,
                errorHandler
            )
        },

        checkRouteAndRedirect() {
            if(this.$route.name === 'setupProfileLogo') 
                this.$router.push({ name : 'setupProfileDetails' })
            else {
                this.$router.push({ name : 'setupProfileLogo' });
                this.heading = 'Logo'
            } 
        }
    }
}
</script>

<style lang="scss" scoped>

.upload-button {
    background: rgba(87, 215, 192, 0.05);
    border-radius: 5px;
    padding: 15px 5px;
    margin-top: 20px;
    font-size: 0.95rem;
}

.drag-drop {
    background: #FBFDFC;
    border: 1px dashed #DBDBDB;
    color: #B8C4B9;
    box-sizing: border-box;
    border-radius: 7px;
    flex-direction: column;
    padding: 50px 0;
    margin: 20px 0 30px 0;
    position: relative;

    p {
        margin: 0;
    }
}

.drag-drop > div {
    width: 100px;
    height: 100px;
    position: absolute;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 3px;
    top: 50%;
    transform: translateY(-50%);
}

.remove-image {
    background: rgba(125, 125, 125, 0.47);
    border-radius: 50%;
    position: absolute;
    right: 4px;
    top: 3px;
}

.drag-drop img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.buttons-section {
    justify-content: space-between;
}

button {
    width: 49%;
    padding: 15px;
    border-radius: 3px;
}

button:disabled {
    opacity: 0.5;
}

.previous {
    background: rgba(44, 171, 109, 0.11);
}

</style>